module.exports = __webpack_public_path__ + "static/media/start_panning.1eed71de.svg";